<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>{{Odaitems.HotelName}} {{ $t('Room-Details') }} </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- <v-btn flat @click="Rezgonder()"> <span class="hidden-sm-and-down"> Rezervasyon Yap </span>
                            <v-icon right dark>add_box</v-icon>
                        </v-btn> -->
                </v-toolbar>
            </v-flex>
        </v-layout>
    </v-card>

    <v-card v-if="loadingdialog == false" color="grey lighten-5" flat>
        <v-flex pt-2 xs12 sm12 md12>
            <v-layout row wrap>

                <v-flex pl-2 v-if="Odaitems!=[]" xs12 sm5 md5>
                    <v-carousel cycle height="450" hide-delimiter-background show-arrows-on-hover>
                        <v-carousel-item v-for="(item,i) in Odaitems.HotelImageList" :key="i" :src="item.Url">
                        </v-carousel-item>
                    </v-carousel>
                </v-flex>

                <v-flex xs12 sm7 v-if="Odaitems!=[]" md7 pr-2>
                    <v-card flat style="min-height:450px">

                        <v-flex xs12 v-if="Odaitems!=[]" sm12 pl-1 md12>
                            <v-layout row wrap>

                                <v-flex xs12 sm12 pb-4 pl-2 pt-3 md12>
                                    <v-layout row wrap class=" project overdue">
                                        <v-toolbar flat="" size="120px" dark color="white">
                                            <v-toolbar-title>

                                                <span class="headline black--text font-weight-bold">
                                                    {{Odaitems.HotelName}}/{{Odaitems.CityName}}
                                                </span>
                                            </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                    </v-layout>
                                </v-flex>

                                <v-flex pl-4 xs12 sm12 md12>
                                    <div class="title font-weight-">
                                        <v-icon color="grey">local_hotel</v-icon>&nbsp; {{ $t('About-the-Facility') }}
                                    </div>
                                </v-flex>
                                <v-flex pl-4 pt-2 xs12 sm12 md12>
                                    <div class="subtitle-2	 font-weight-light">
                                        {{Odaitems.Message}}
                                    </div>
                                </v-flex>
                                <v-flex pl-4 pt-2 xs12 sm12 md12>
                                    <div class="title font-weight-">
                                        <v-icon color="grey">location_on</v-icon>&nbsp; {{$t('Address_label')}}
                                    </div>
                                    <div class="subtitle-2	 font-weight-light">
                                        {{Odaitems.Address}} &nbsp; {{Odaitems.CityName}}/ {{Odaitems.CountryLongName}}
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-card>
                </v-flex>

                <v-flex xs12 v-if="Odaitems!=[]" pr-2 pl-2 sm12 md12>
                    <v-card flat>
                        <v-flex xs12 sm12 md12>
                            <v-layout class=" project overdue" row wrap>

                                <v-expansion-panel expand>
                                    <v-expansion-panel-content>
                                        <div slot="header">

                                            <v-flex xs12 sm12 md12>
                                                <v-layout row wrap>
                                                    <span class="title black--text font-weight-bold">
                                                        {{ $t('Other-Features-Hotel') }}
                                                    </span>

                                                </v-layout>
                                            </v-flex>

                                        </div>
                                        <v-card flat>
                                            <v-card-text>
                                                <v-layout row wrap>
                                                    <v-flex pa-4 xs12 sm6 md3>
                                                        <div class="headline">
                                                            <v-icon color="primary">local_play</v-icon> 
                                                            {{ $t('Facility-Features') }}
                                                        </div>
                                                        <v-flex pl-4 v-for="(item,index) in Odaitems.HotelPropertyList" v-bind:key="index" pt-2 xs12 sm8 md12>
                                                            <div class="font-weight-medium">
                                                                <v-icon small color="grey">check</v-icon>
                                                                {{item.FilterName}}
                                                            </div>
                                                        </v-flex>

                                                    </v-flex>

                                                    <v-flex pa-4 xs12 sm6 md3>
                                                        <div class="headline">
                                                            <v-icon color="primary">apartment</v-icon> 
                                                            {{ $t('Facilty-Services') }}
                                                        </div>
                                                        <v-flex pl-4 v-for="(item,index) in Odaitems.HotelServiceList" v-bind:key="index" pt-2 xs12 sm8 md12>
                                                            <div class="font-weight-medium">
                                                                <v-icon small color="grey">check</v-icon>
                                                                {{item.FilterName}}
                                                            </div>
                                                        </v-flex>
                                                    </v-flex>

                                                    <v-flex pa-4 xs12 sm6 md3>
                                                        <div class="headline">
                                                            <v-icon color="primary">hotel</v-icon> {{ $t('Room-Features') }}
                                                        </div>
                                                        <v-flex pl-4 v-for="(item,index) in Odaitems.RoomPropertyList" v-bind:key="index" pt-2 xs12 sm8 md12>
                                                            <div class="font-weight-medium">
                                                                <v-icon small color="grey">check</v-icon>
                                                                {{item.FilterName}}
                                                            </div>
                                                        </v-flex>
                                                    </v-flex>

                                                    <v-flex pa-4 xs12 sm6 md3>
                                                        <div class="headline">
                                                            <v-icon color="primary">shopping_cart</v-icon> {{ $t('Price-Details') }}
                                                        </div>
                                                        <v-flex pl-4 v-for="(item,index) in Odaitems.RoomPriceDetailList" v-bind:key="index" pt-2 xs12 sm8 md12>
                                                            <div class="font-weight-medium">
                                                                <v-icon small color="grey">arrow_right</v-icon>
                                                                {{item.ArkmanPrice | moneyformat}} {{item.CurrencyType}}
                                                            </div>
                                                        </v-flex>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>

                            </v-layout>
                        </v-flex>

                    </v-card>
                </v-flex>

                <v-flex pa-2 xs12 v-if="Odaitems.OdaFiyatDetay != []" sm12 md12>
                    <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">

                            <v-list>
                                <v-layout style="border-style: solid; border-width: 5px; border-color:green;" row wrap>
                                    <v-flex xs12 sm3 md3>

                                        <v-img :src="getodaGorsel()" height="245" width="100%">
                                        </v-img>
                                        <v-layout justify-center>
                                            <v-btn @click="getodaDetay(0,null)" flat color="green">
                                                <span class="body-1 font-weigh-bold	info--text"> 
                                                 {{ $t('Room-Details') }}    
                                                </span></v-btn>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                        <v-list-tile>
                                            <span class='font-weight-black'>
                                                <h2> {{Odaitems.HotelName}}</h2>
                                            </span>
                                            <v-icon large color="green">assistant_photo</v-icon>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <span class='font-weight-medium' style="padding-top:20px">
                                                <v-icon color="grey">gps_fixed</v-icon>

                                                {{Odaitems.CityName}},{{Odaitems.CountryLongName}}
                                                <!--Harita' alanı eklenebilir - <a href="#">Haritada Göster</a>-->
                                            </span>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <span class='font-weight-medium'>
                                                <v-icon color="grey">location_on</v-icon>
                                                {{Odaitems.Address}}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <span class="font-weight-light caption">
                                                ---  {{  $t('Night-Total-Amount') }}
                                            </span>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <span class="font-weight-black">
                                                <v-icon color="grey">alarm</v-icon>
                                                {{Odaitems.CheckInTime | dateformat }}
                                                {{Odaitems.CheckInTime | gettime }} -
                                                {{Odaitems.CheckOutTime | dateformat}}
                                                {{Odaitems.CheckOutTime | gettime}}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <span class="font-weight-black mr-1">
                                                <h2> {{Odaitems.ArkmanPrice | moneyformat}}
                                                    {{Odaitems.CurrencyType}}</h2>
                                            </span>
                                        </v-list-tile>

                                        <v-list-tile>
                                            <span class="font-weight-black mr-1">
                                                <v-icon color="grey">meeting_room</v-icon>
                                                {{Odaitems.RateName}}
                                                <v-icon v-if="Odaitems.ReturnStatus==1" color="green">check</v-icon>
                                                <span v-if="Odaitems.ReturnStatus==1" class="green--text">iade dilebilir</span>
                                            </span>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="Rezgonder()" color="green">
                                                <span class="subtitle-1	 white--text">  {{ $t('Make-a-Reservation') }} </span>

                                            </v-btn>
                                        </v-list-tile>

                                    </v-flex>
                                </v-layout>
                            </v-list>
                        </v-card>
                    </v-hover>
                </v-flex>

                <v-flex pa-2 xs12 v-if="Odaitems.OdaFiyatDetay != []" sm12 md12>
                    <v-card flat>

                        <v-flex xs12 sm12 md12>
                            <v-layout row wrap v-show="onerilenkayitvarmi">

                                <v-flex pb-2 v-for="(item,index) in onerilenodaitems" v-bind:key="index" xs12 sm12 md12>

                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`" width="100%">

                                            <v-list>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm3 md3>

                                                        <v-img :src="item.RoomImageList | ilkfoto" height="245" width="100%">
                                                        </v-img>
                                                        <v-layout justify-center>
                                                            <v-btn @click="getodaDetay(1,item)" flat color="green">
                                                                <span class="body-1 font-weigh-bold	info--text"> 
                                                                 {{ $t('Room-Details') }}        
                                                                </span></v-btn>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm9 md9>
                                                        <v-list-tile>
                                                            <span class='font-weight-black'>
                                                                <h2> {{item.HotelName}}</h2>
                                                            </span>
                                                            <!-- <v-icon large color="green">
                                                                assistant_photo</v-icon> -->
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <span class='font-weight-medium' style="padding-top:20px">
                                                                <v-icon color="grey">gps_fixed</v-icon>
                                                                {{item.CityName}},{{item.CountryName}}
                                                                <!--Harita' alanı eklenebilir - <a href="#">Haritada Göster</a>-->
                                                            </span>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <span class='font-weight-medium'>
                                                                <v-icon color="grey">location_on</v-icon>
                                                                {{item.Address}}
                                                            </span>
                                                            <v-spacer></v-spacer>
                                                            <span class="font-weight-light caption">
                                                                {{item.NightCount}} {{  $t('Night-Total-Amount') }}
                                                            </span>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <span class="font-weight-black">
                                                                <v-icon color="grey">alarm</v-icon>
                                                                {{item.CheckInTime | dateformat}}
                                                                {{item.CheckInTime | gettime}} -
                                                                {{item.CheckOutTime | dateformat}}
                                                                {{item.CheckOutTime | gettime}}
                                                            </span>
                                                            <v-spacer></v-spacer>
                                                            <span class="font-weight-black mr-1">
                                                                <h2>{{item.ArkmanPrice | moneyformat}} {{item.CurrencyType}}</h2>
                                                            </span>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <span class="font-weight-black mr-1">
                                                                <v-icon color="grey">meeting_room</v-icon>
                                                                {{item.RateName}}
                                                            </span>
                                                            <v-icon v-if="item.ReturnStatus==1" color="green">check
                                                            </v-icon><span v-if="item.ReturnStatus==1" class="green--text"> {{ $t('Refundable') }} </span>
                                                            <v-spacer></v-spacer>
                                                            <v-btn @click="idgonder(item)" color="green">
                                                                <span class="subtitle-1	 white--text"> {{ $t('Make-a-Reservation') }}</span>

                                                            </v-btn>
                                                        </v-list-tile>

                                                    </v-flex>
                                                </v-layout>
                                            </v-list>
                                        </v-card>
                                    </v-hover>
                                </v-flex>

                            </v-layout>
                        </v-flex>

                    </v-card>
                </v-flex>

            </v-layout>
        </v-flex>

    </v-card>
    <hotelloadingcomp ref="hotelloadingcomp" iconname="local_hotel"  v-bind:mesaj="$t('Your-detailed-hotel-room-information-are-being-accessed')" v-model="loadingdialog">
    </hotelloadingcomp>

    <v-dialog v-model="odadetaydialog" v-if="odadetaydialog" scrollable="" persistent="" max-width="500px">
        <v-card>
            <v-card-title>{{odadetayi.SinifAd}}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <v-flex xs12 sm12 md12>
                        <v-card flat class="white--text">
                            <v-card flat="">
                                <v-card-actions>

                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-carousel height="245">
                                                <v-carousel-item v-for="(item,i) in odadetayi.OdaGorsel" :key="i" :src="item.Url">
                                                </v-carousel-item>
                                            </v-carousel>
                                        </v-flex>

                                        <v-flex xs12 sm12 pt-3 md12>
                                            <div class="subtitle-1 font-weigth-bold"> {{ $t('Room-Features') }}
                                            </div>

                                            <v-layout row wrap>
                                                <v-flex v-for="(item,index) in odadetayi.OdaOzellik" v-bind:key="index" pt-2 xs12 sm6 md6>
                                                    <div>
                                                        <v-icon small color="grey">check</v-icon>
                                                        {{item.FilterName}}
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>

                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="odadetaydialog=false">{{$t('Close')}}</v-btn>

                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tarihim from "@/components/app/customcomp/tarihim.vue"
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
    data() {
        return {
            yetkidialog: false,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
            islemTipi: null,
            odadetaydialog: false,
            odadetayi: {},
            loadingdialog: false,
            validform: true,
            search: '',
            kayitvarmi: false,
            onerilenkayitvarmi: false,
            oteladitems: [],
            onerilenodaitems: [],
            ozellikitems: [],
            servisitems: [],
            otelozellikitems: [],
            otelservisitems: [],
            odaAditems: [],
            odaOzellikAdiitems: [],
            yetiskinSayi: 1,
            Azalt: false,
            toplamFiyat: 0,
            menu: false,
            odaSayi: 0,
            OtelAdOzel: '',
            loadodaitems: null,
            OtelAdTitle: false,
            siralamatipiitems: [{
                text: this.$t('Price-Ascending'),
                value: 'Price'
            }, {
                text: this.$t('Price-Descending'),
                value: 'PriceDesc'
            }],
            kayitsayisi: [{
                text: '50',
                value: 50
            }, {
                text: '100',
                value: 100
            }],
            items: [{
                    src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
                },
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
                },
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
                },
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
                }
            ],
            FiyatInput: {
                MarkupTip: 0,
                MarkupDeger: 0,
                OtelID: null,
                Sehir: null,
                BaslangicTarih: null,
                BitisTarih: null,
                KisiSayi: null,
                Siralama: null,
                Min: 0,
                Max: 0,
                CocukUcretsiz: null,
                CocukUcretli: null,
                CocukKabul: 2,
            },
            SearchInput: {
                LocationKey: null,
                LocationName: null,
                StartDate: null,
                EndDate: null,
                Adt: 0,
                MarkupType: 0,
                MarkupPrice: 0,
                MinPrice: 0,
                MaxPrice: 0,
                Language: null,
                SortType: null,
                ChildAccept: 2,
                CurrencyType: null,
                HotelPropertiesList: [],
                HotelServiceList: [],
                RoomPropertiesList: []
            },
            Odaitems: {
                OdaAd: null,
                OdaID: 0,
                OtelImage: null,
                SinifID: 0,
                SinifAd: null,
                Tarih: null,
                Fiyat: 0.0,
                Kur: null,
                MinDurum: false,
                Cta: false,
                Ctd: false,
                TotalCount: 0,
                TotalPage: 0.0,
                Olcu: 0,
                MaxKisi: 0,
                MaxDoluluk: 0,
                YatakSayi: 0,
                OtelAd: null,
                HrOtelID: 0,
                OtelID: 0,
                Ulke: null,
                Sehir: null,
                Adres: null,
                GirisSaat: null,
                CikisSaat: null,
                CocukKabul: 2,
                Enlem: 0.0,
                Boylam: 0.0,
                Mesaj: null,
                OtelOzellik: [],
                OtelServis: [],
                OdaGorsel: [],
                OdaFiyatDetay: []

            }
        }
    },
    methods: {
        getodaDetay(id, val) {
            if (id == 0) {
                var detay = {
                    OdaAd: this.Odaitems.RoomName,
                    OdaGorsel: this.Odaitems.RoomImageList,
                    SinifAd: this.Odaitems.RateName,
                    OdaOzellik: this.Odaitems.RoomPropertyList
                }
                this.odadetayi = detay

            } else if (id == 1) {
                var detay = {
                    OdaAd: val.RoomName,
                    OdaGorsel: val.RoomImageList,
                    SinifAd: val.RateName,
                    OdaOzellik: val.RoomPropertyList
                }
                this.odadetayi = detay
            }

            this.odadetaydialog = true
        },
        getodaGorsel() {

            if (this.Odaitems.RoomImageList.length > 0) {
                return this.Odaitems.RoomImageList[0].Url
            }
        },
        Rezgonder() {
            var url = '#/hotelrunner/rezervasyon/id?' + '&SinifAd=' + this.Odaitems.RateName + '&CocukSayi=' + this
                .Odaitems.ChildCount + '&ArkmanOtelID=' + this.Odaitems.ArkmanHotelId + '&OdaID=' + this.Odaitems.RoomId +
                '&Sehir=' + this.Odaitems.CityName + '&OtelAd=' + this.Odaitems.HotelName + '&BasTarih=' + this.FiyatInput
                .BaslangicTarih + '&BitTarih=' + this.FiyatInput.BitisTarih + '&YetiskinSayi=' + this.yetiskinSayi +
                '&OdaTipi=' + this.Odaitems.OdaAd + '&ToplamTutar=' + this.Odaitems.Fiyat + '&Kur=' + this.Odaitems
                .CurrencyType + '&Adres=' + this.Odaitems.Address + '&OtelID=' + this.Odaitems.ServiceHotelId + '&RateID=' + this
                .Odaitems.RateId + '&Ulke=' + this.Odaitems.CountryLongName + '&MarkupTip=' + this.FiyatInput
                .MarkupTip + '&MarkupDeger=' + this.FiyatInput.MarkupDeger + '&islemTip=' + this.islemTipi

            window.open(url, '_self')
        },
        idgonder(val) {

            var url = '#/hotelrunner/rezervasyon/id?' + '&SinifAd=' + val.RateName + '&CocukSayi=' + this
                .Odaitems.ChildCount + '&ArkmanOtelID=' + val.ArkmanHotelId + '&OdaID=' + val.RoomId +
                '&Sehir=' + val.CityName + '&OtelAd=' + val.HotelName + '&BasTarih=' + this.FiyatInput
                .BaslangicTarih + '&BitTarih=' + this.FiyatInput.BitisTarih + '&YetiskinSayi=' + this.yetiskinSayi +
                '&OdaTipi=' + val.RoomName + '&ToplamTutar=' + val.ArkmanPrice + '&Kur=' + val.CurrencyType + '&Adres=' + val.Address +
                '&OtelID=' + val.ServiceHotelId + '&RateID=' + val.RateId + '&MarkupTip=' + this.FiyatInput
                .MarkupTip + '&MarkupDeger=' + this.FiyatInput.MarkupDeger + '&islemTip=' + this.islemTipi

            window.open(url, '_self')

        },
        yetiskinArttir() {

            this.Azalt = false;
            this.yetiskinSayi++;

        },
        yetiskinAzalt() {
            if (this.yetiskinSayi >= 2) {
                this.yetiskinSayi--;
            } else {
                this.Azalt = true;
            }

        },
        OnerilenlerCek: OnerilenlerCek,
        FiyatCek: FiyatCek,
        OtelCek: OtelCek,
        OtelOzellik: OtelOzellik,
        OtelServis: OtelServis,
        OdaOzellik: OdaOzellik
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        coperdateformat: function (t) {
            return helpers.coperdateformat(t);
        },

        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
        gettime: function (t) {
            return helpers.getTime(t);
        },
        ilkfoto: function (a) {
            return a[0].Url
        }
    },
    watch: {
        search(val) {
            val && this.OtelCek(val)
        },
    },
    components: {
        tarihim,
        hotelloadingcomp,
        yetkidialog
    },
    beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.loadingdialog = true

    if (this.$route.query.islemTip != undefined && this.$route.query.islemTip != null) {

        if (this.$route.query.islemTip == 'hrget') {
            this.islemTipi = 'hrget'
        } else {
            this.islemTipi = 'hryeni'
        }
    } else {
        this.islemTipi = 'hryeni'
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var ParaBirimi = credentials.ParaBirimi;

    this.FiyatInput.MarkupTip = this.$route.query.MarkupTip;
    this.FiyatInput.MarkupDeger = this.$route.query.MarkupDeger;
    this.FiyatInput.BaslangicTarih = this.$route.query.basTarih;
    this.FiyatInput.BitisTarih = this.$route.query.bitTarih;
    this.yetiskinSayi = this.$route.query.KisiSayi;
    this.FiyatInput.Siralama = this.$route.query.Siralama;
    this.FiyatInput.Max = this.$route.query.Max;
    this.FiyatInput.Min = this.$route.query.Min;
    this.FiyatInput.CocukKabul = this.$route.query.CocukKabul;
    var suggestedParam = JSON.parse(window.localStorage.getItem('suggestedParams'));

    var params = {
        LogInput: {
            UserID: credentials.UserID,
            CustomerID: credentials.MusteriID
        },
        RateId: this.$route.query.rateid,
        StartDate: this.$route.query.basTarih,
        EndDate: this.$route.query.bitTarih,
        Language: "tr",
        MarkupType: this.FiyatInput.MarkupTip,
        MarkupPrice: this.FiyatInput.MarkupDeger,
        Adt: this.yetiskinSayi,
        CurrencyType: ParaBirimi,
        ChildAgeList: suggestedParam.ChildAgeList
    };


    this.$http.post(auth.HOTELRUNNER_API_URL + 'api/v1/Select', params, {
            headers: {
                'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                    .HOTELRUNNERUSERPASS)
            }
        }

    ).then((response) => {
        this.Odaitems = response.body;
        this.Odaitems.OtelOzellik = response.body.HotelPropertyList
        this.Odaitems.OtelServis = response.body.HotelServiceList
        this.Odaitems.Odagorsel = response.body.RoomImageList
        this.Odaitems.OdaFiyatDetay = response.body.RoomPriceDetailList
        this.Odaitems.OdaOzellik = response.body.RoomPropertyList

        this.OnerilenlerCek(response.body.ServiceHotelId, response.body.CityName);
        this.loadingdialog = false

    }, (response) => {

        if (response.status === 0) {

            this.loadingdialog = false

            this.text1 = 'Service Unavailable-Select'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-Select'
            this.snackbar = true
            this.progress = false
        }
    })

    var Dilparams = {
        Dil: "tr"
    }
    //HRFacilityTypes -- Otel Ozellikleri Çekiliyor.
    // this.$http.post(auth.HOTELRUNNER_API_URL + 'api/Otels/OtelOzellikList', Dilparams).then((response) => {
    //     this.ozellikitems = response.body;
    // }, (response) => {
    //     if (response.status === 0) {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     } else {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     }
    // })

    //HRServiceTypes -- Otel Servisleri Çekiliyor.
    // this.$http.post(auth.HOTELRUNNER_API_URL + 'api/Otels/OtelServisAdList', Dilparams).then((response) => {
    //     this.servisitems = response.body;
    // }, (response) => {
    //     if (response.status === 0) {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     } else {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     }
    // })

    //HRSalesRoomPropertyTypes -- Oda Özellikleri Çekiliyor.
    // this.$http.post(auth.HOTELRUNNER_API_URL + 'api/Otels/OdaOzellikAdList', Dilparams).then((response) => {
    //     this.odaAditems = response.body;
    // }, (response) => {
    //     if (response.status === 0) {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     } else {
    //         this.text1 = 'Service Unavailable-OzellikList'
    //         this.snackbar = true
    //         this.progress = false
    //     }
    // })
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
}


function OdaOzellik(id) {
    var konum = this.odaOzellikAdiitems.indexOf(id); //seçilen id dizide varmı kontrol ediliyor
    if (konum !== -1) {
        //eğer daha önce seçili ve tekrar tıklandıysa diziden siliniyor.
        this.odaOzellikAdiitems.splice(konum, 1)
    } else {
        //ilk defa seçildi ise diziye ekleniyor.
        this.odaOzellikAdiitems.push(id);
    }
    this.FiyatCek()
}

function OtelServis(id) {
    var konum = this.otelservisitems.indexOf(id); //seçilen id dizide varmı kontrol ediliyor
    if (konum !== -1) {
        //eğer daha önce seçili ve tekrar tıklandıysa diziden siliniyor.
        this.otelservisitems.splice(konum, 1)
    } else {
        //ilk defa seçildi ise diziye ekleniyor.
        this.otelservisitems.push(id);
    }
    this.FiyatCek()
}

function OtelOzellik(id) {
    var konum = this.otelozellikitems.indexOf(id); //seçilen id dizide varmı kontrol ediliyor
    if (konum !== -1) {
        //eğer daha önce seçili ve tekrar tıklandıysa diziden siliniyor.
        this.otelozellikitems.splice(konum, 1)
    } else {
        //ilk defa seçildi ise diziye ekleniyor.
        this.otelozellikitems.push(id);
    }
    this.FiyatCek()
}

function FiyatCek() {

    if (this.$refs.FiyatCek.validate()) {
        //Tarih Kontrolleri

        //Bugunun Tarihi Baslangic Tarihi ile kıyaslamak için
        var date = new Date();
        var Bugun = date.toLocaleDateString("tr-TR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        //Başlangıç Tarihi
        var date2 = new Date(this.FiyatInput.BaslangicTarih);
        var BasTarih = date2.toLocaleDateString("tr-TR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        //Bitiş Tarihi
        var date3 = new Date(this.FiyatInput.BitisTarih);
        var BitisTarih = date3.toLocaleDateString("tr-TR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });

        if (BasTarih >= Bugun && BitisTarih > BasTarih) { //Tarihler kontrol edildi
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            if (this.FiyatInput.CocukUcretli == true) {
                this.FiyatInput.CocukKabul = 0
            } else if (this.FiyatInput.CocukUcretli == false) {
                this.FiyatInput.CocukKabul = null
            }
            if (this.FiyatInput.CocukUcretsiz == true) {
                this.FiyatInput.CocukKabul = 1
            } else if (this.FiyatInput.CocukUcretsiz == false) {
                this.FiyatInput.CocukKabul = null
            }

            var InputType = typeof this.FiyatInput.Sehir;
            if (InputType == "number") { //Otel ID ' e göre arama

                var params = {
                    LogInput: {
                        UserID: credentials.UserID,
                        CustomerID: credentials.MusteriID
                    },
                    OtelID: this.FiyatInput.Sehir,
                    Sehir: null,
                    BaslangicTarih: this.FiyatInput.BaslangicTarih,
                    BitisTarih: this.FiyatInput.BitisTarih,
                    KisiSayi: this.yetiskinSayi,
                    Siralama: this.FiyatInput.Siralama,
                    Min: this.FiyatInput.Min,
                    Max: this.FiyatInput.Max,
                    CocukKabul: this.FiyatInput.CocukKabul,
                    OtelOzellik: this.otelozellikitems,
                    OtelServis: this.otelservisitems,
                    OdaOzellik: this.odaOzellikAdiitems
                }

            } else if (InputType != "number") { //Konuma Göre arama
                var Search = this.FiyatInput.Sehir.split(" ");
                var SearchValue = Search[0];

                var params = {
                    LogInput: {
                        UserID: credentials.UserID,
                        CustomerID: credentials.MusteriID
                    },
                    OtelID: 0,
                    Sehir: SearchValue,
                    BaslangicTarih: this.FiyatInput.BaslangicTarih,
                    BitisTarih: this.FiyatInput.BitisTarih,
                    KisiSayi: this.yetiskinSayi,
                    Siralama: this.FiyatInput.Siralama,
                    Min: this.FiyatInput.Min,
                    Max: this.FiyatInput.Max,
                    CocukKabul: this.FiyatInput.CocukKabul,
                    OtelOzellik: this.otelozellikitems,
                    OtelServis: this.otelservisitems,
                    OdaOzellik: this.odaOzellikAdiitems

                }
            }


            this.$http.post(auth.API_URL + 'api/Otels/FiyatList', params, {
                headers: {
                'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                        .HOTELRUNNERUSERPASS)
                }
            }).then((response) => {
                this.kayitvarmi = true;
                this.loadodaitems = response.body;
                this.odaSayi = this.loadodaitems.length;

                //Arama OtelID'e göre yapıldı ise Otel Adı alanı düzenleniyor.
                var titleInput = typeof this.FiyatInput.Sehir;
                if (titleInput == "number") {
                    this.OtelAdTitle = true
                    this.OtelAdOzel = response.body[0].OtelAd
                }

            }, (response) => {

                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-FiyatList'
                    this.snackbar = true
                    this.progress = false
                } else {
                    this.text1 = 'Service Unavailable-FiyatList'
                    this.snackbar = true
                    this.progress = false
                }
            })

        } else {
            this.text1 = this.$t('Incorrect-Date-Entry')
            this.snackbar = true
        }
    } else {
        this.text1 = this.$t('Search-Hotel-Field-Cannot-be-Empty')
        this.snackbar = true
    }

}

function OnerilenlerCek(OtelID, Key) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.FiyatInput.CocukUcretli == true) {
        this.FiyatInput.CocukKabul = 0
    }
    if (this.FiyatInput.CocukUcretsiz == true) {
        this.FiyatInput.CocukKabul = 1
    }

    var params = JSON.parse(window.localStorage.getItem('suggestedParams'));
    params.Paging.DataCount = 5;

    this.$http.post(auth.HOTELRUNNER_API_URL + "api/v1/Search", params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.onerilenodaitems = response.body;
        if (this.onerilenodaitems.length > 0) {
            this.onerilenkayitvarmi = true;
        }

    }, (response) => {

        if (response.status === 0) {
            this.text1 = 'Service Unavailable-FiyatList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-FiyatList'
            this.snackbar = true
            this.progress = false
        }
    })

}

function OtelCek(val) {
    var params = {
        Sehir: escape(val)
    }
    if (val.length >= 0) {
        setTimeout(() => {
            this.$http.post(auth.API_URL + 'api/Otels/OtelAdresList', params, {}).then((response) => {
                this.otelitems = response.body
                //Otel Konum'a göre dolduruluyor
                for (var i = 0; i < this.otelitems.length; i++) {
                    this.OtelText = this.otelitems[i].OtelAdres;
                    this.OtelValue = this.otelitems[i].OtelDeger;
                    var degerAdres = true;
                    this.oteladitems.push({
                        name: this.OtelText,
                        value: this.OtelValue,
                        deger: degerAdres
                    })

                }
                // Oteller ID'lere göre dolduruluyor
                for (var d = 0; d < this.otelitems.length; d++) {
                    var name = this.otelitems[d].OtelAd;
                    var value = this.otelitems[d].OtelID;
                    var deger = false;
                    this.oteladitems.push({
                        name: name,
                        value: value,
                        deger: deger
                    })
                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-OtelAdresList'
                    this.snackbar = true
                    this.progress = false
                } else {
                    this.text1 = 'Service Unavailable-OtelAdresList'
                    this.snackbar = true
                    this.progress = false
                }
            })
        }, 500)
    }
}
</script>
